// Set user token
export const SET_USER_TOKEN_SUCCESS = 'SET_USER_TOKEN_SUCCESS';
export const SET_USER_TOKEN_ERROR = 'SET_USER_TOKEN_ERROR';

// Fetch email subscriptions
export const FETCH_EMAIL_SUBSCRIPTIONS = 'FETCH_EMAIL_SUBSCRIPTIONS';
export const FETCH_EMAIL_SUBSCRIPTIONS_SUCCESS = 'FETCH_EMAIL_SUBSCRIPTIONS_SUCCESS';
export const FETCH_EMAIL_SUBSCRIPTIONS_ERROR = 'FETCH_EMAIL_SUBSCRIPTIONS_ERROR';

// Update email subscriptions
export const UPDATE_EMAIL_SUBSCRIPTIONS = 'UPDATE_EMAIL_SUBSCRIPTIONS';
export const UPDATE_EMAIL_SUBSCRIPTIONS_SUCCESS = 'UPDATE_EMAIL_SUBSCRIPTIONS_SUCCESS';
export const UPDATE_EMAIL_SUBSCRIPTIONS_ERROR = 'UPDATE_EMAIL_SUBSCRIPTIONS_ERROR';
